/* Preorder fit ranges for the regular $199 suits (loaded only on those product pages).
   Out-of-stock sizes are made to order: Slim fit in jacket sizes 36–46, Modern fit in 40–52.
   In-stock sizes are not affected. When a preorder falls outside its fit's range, the shopper sees which fit to
   choose and the Preorder / Add the full look buttons won't add it to the bag. */
(() => {
  const ranges = window.GiorgioPreorderFit || { Slim: [36, 46], Modern: [40, 52] };
  const product = document.querySelector('.g-product');
  if (!product) return;
  const form = product.querySelector('.g-product-form');
  if (!form) return;

  const jacket = () => {
    const input = form.querySelector('fieldset[data-option-name="Jacket Size"] input:checked');
    return input ? parseInt(input.value, 10) : NaN;
  };
  const fit = () => form.querySelector('input[name="properties[Fit]"]:checked')?.value || '';
  const preorder = () => product.querySelector('[data-g-preorder]')?.dataset.active === 'true';

  const problem = () => {
    if (!preorder()) return '';
    const size = jacket();
    const chosen = fit();
    const range = ranges[chosen];
    if (!range || Number.isNaN(size)) return '';
    if (size >= range[0] && size <= range[1]) return '';
    const other = Object.keys(ranges).find((name) => name !== chosen && size >= ranges[name][0] && size <= ranges[name][1]);
    let text = `${chosen} fit is made to order in jacket sizes ${range[0]}–${range[1]}.`;
    text += other ? ` For a ${size} jacket, choose ${other} fit.` : ' Contact our team and we’ll help with this size.';
    return text;
  };

  const note = document.createElement('p');
  note.className = 'g-preorder-fit-note';
  note.setAttribute('role', 'alert');
  note.tabIndex = -1;
  note.hidden = true;
  note.style.cssText = 'margin:10px 0;padding:10px 12px;border:1px solid #9b1b24;background:#fdf3f3;color:#7a141c;font-size:14px;line-height:1.45';

  const place = () => {
    if (note.isConnected) return;
    const anchor = product.querySelector('[data-g-preorder]');
    if (anchor) anchor.after(note);
    else form.querySelector('.g-product-add')?.before(note);
  };

  const update = () => {
    place();
    const text = problem();
    note.textContent = text;
    note.hidden = !text;
    return text;
  };

  const block = (event) => {
    const text = update();
    if (!text) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    note.focus({ preventScroll: true });
    note.scrollIntoView({ block: 'center', behavior: 'smooth' });
  };

  document.addEventListener('click', (event) => {
    if (event.target.closest?.('[data-product-submit], [data-sticky-submit], .g-look__all')) block(event);
  }, true);
  document.addEventListener('submit', (event) => { if (event.target === form) block(event); }, true);
  document.addEventListener('change', () => setTimeout(update, 0), true);

  let queued = false;
  const observer = new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; update(); });
  });
  const start = () => {
    update();
    observer.observe(product, { attributes: true, attributeFilter: ['data-active', 'data-state'], subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
